import React from 'react';

import { FooterData } from '../../layouts/mock';
import NotAuthenticatedView from './not-authenticated.view';

const NotAuthenticatedController: React.FC = () => {
  return <NotAuthenticatedView footerData={FooterData} />;
};

export default NotAuthenticatedController;
